import {
    ICadastraEEditaHorarioDisponivelHorario,
    ICompromissoDisponivelVistoria,
} from "../../../Interfaces/VistoriaEntregaChaves/CompromissoDisponivel/CompromissoDisponivelInterfaces";
import {
    CadastrarCompromissoDisponivelVistoriaService,
    CadastrarHorariosDisponiveisService,
    DeletarHorariosDisponiveisService,
    EditarHorariosDisponiveisService,
    ListarCompromissoDisponivelHorarioDisponiveisService,
    ListarCompromissoDisponivelHorarioService,
    ListarHorariosDisponiveisService,
    ListarUsuariosCompromissoDisponivelHorariosService,
    TransfereCompromissoService,
} from "../../../Services/VistoriaEntregaDeChaves/CompromissoDisponivel/CompromissoDisponivelServices";
import { Controller } from "../../Controller";

export async function ListarCompromissoDisponivelHorarioController(
    data: string,
    idEmpreendimento: number,
    idUsuario?: number,
    idCaso?: number,
    flTelaAgendamento?: boolean
) {
    return Controller(
        ListarCompromissoDisponivelHorarioService(
            data,
            idEmpreendimento,
            idUsuario,
            idCaso,
            flTelaAgendamento
        )
    );
}

export async function ListarCompromissoDisponivelHorarioDisponiveisController(
    data: string,
    idEmpreendimento: number,
    idUsuario?: number,
    idCaso?: number
) {
    return Controller(
        ListarCompromissoDisponivelHorarioDisponiveisService(
            data,
            idEmpreendimento,
            idUsuario,
            idCaso
        )
    );
}

export async function CadastrarCompromissoDisponivelVistoriaController(
    requestBody: ICompromissoDisponivelVistoria
) {
    return Controller(
        CadastrarCompromissoDisponivelVistoriaService(requestBody)
    );
}

export async function ListarUsuariosCompromissoDisponivelHorariosController(
    data: string,
    idEmpreendimento: number
) {
    return Controller(
        ListarUsuariosCompromissoDisponivelHorariosService(
            data,
            idEmpreendimento
        )
    );
}

export async function TransfereCompromissoController(
    ID_TIPO_COMPROMISSO: number,
    ID_USUARIO_REMETENTE: number,
    ID_USUARIO_DESTINATARIO: number
) {
    return Controller(
        TransfereCompromissoService(
            ID_TIPO_COMPROMISSO,
            ID_USUARIO_REMETENTE,
            ID_USUARIO_DESTINATARIO
        )
    );
}

export async function ListarHorariosDisponiveisController(
    data?: string,
    idEmpreendimento?: number,
    idUsuario?: number
) {
    return Controller(
        ListarHorariosDisponiveisService(data, idEmpreendimento, idUsuario)
    );
}

export async function CadastrarHorariosDisponiveisController(
    requestBody: ICadastraEEditaHorarioDisponivelHorario
) {
    return Controller(CadastrarHorariosDisponiveisService(requestBody));
}

export async function AtualizarHorariosDisponiveisController(
    requestBody: ICadastraEEditaHorarioDisponivelHorario
) {
    return Controller(EditarHorariosDisponiveisService(requestBody));
}

export async function DeletarHorariosDisponiveisController(
    idCompromissoHorario: number
) {
    return Controller(DeletarHorariosDisponiveisService(idCompromissoHorario));
}
